function Usecase({ selectedTab, setSelectedTab }) {
  const tabs = [
    "Retail",
    "Transportation",
    "Occupational Safety",
    "Warehousing",
    "Face Recognition",
  ];
  let tabContent = {
    Retail: (
      <div className="container" data-aos="fade-up">
        <div className="row feture-tabs g-4" data-aos="fade-up">
          <div className="col-lg-6">
            <section id="features" className="features">
              <div className="container">
                <div
                  className="row g-5"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <div className="col-lg-6">
                    <div className="icon-box">
                      <img
                        src="assets/usecase/entry_exit.png"
                        height={40}
                        className="mx-2"
                        alt="not found"
                      />
                      
                      <h3>
                        <div>Footfall Monitoring</div>
                      </h3>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="icon-box">
                      <img
                        src="assets/usecase/intrusion.png"
                        height={40}
                        className="mx-2"
                        alt="not found"
                      />
                      <h3>
                        <div>Intrusion Detection</div>
                      </h3>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="icon-box">
                      <img
                        src="assets/usecase/queue.png"
                        height={40}
                        className="mx-2"
                        alt="not found"
                      />{" "}
                      <h3>
                        <div>Queue Length Monitoring</div>
                      </h3>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="icon-box">
                      <img
                        src="assets/usecase/crowd.png"
                        height={40}
                        className="mx-2"
                        alt="not found"
                      />{" "}
                      <h3>
                        <div>Overcrowding Alert</div>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div className="col-lg-6 d-flex justify-content-end align-items-center">
            <img
              src="assets/img/Retail.png"
              className="img-fluid"
              alt=""
              width={500}
            />
          </div>
        </div>
      </div>
    ),
    Transportation: (
      <div className="container" data-aos="fade-up">
        <div className="row feture-tabs g-4" data-aos="fade-up">
          <div className="col-lg-6">
            <section id="features" className="features">
              <div className="container">
                <div
                  className="row g-5"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <div className="col-lg-6">
                    <div className="icon-box">
                      <img
                        src="assets/usecase/vehicle.png"
                        height={40}
                        className="mx-2"
                        alt="not found"
                      />
                      <h3>
                        <div>Traffic Volume Analysis</div>
                      </h3>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="icon-box">
                      <img
                        src="assets/usecase/ANPR.png"
                        height={40}
                        className="mx-2"
                        alt="not found"
                      />
                      <h3>
                        <div>Automatic Number Plate Recognition (ANPR)</div>
                      </h3>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="icon-box">
                      <img
                        src="assets/usecase/speed.png"
                        height={40}
                        className="mx-2"
                        alt="not found"
                      />
                      <h3>
                        <div>Speed Detection and Analysis</div>
                      </h3>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="icon-box">
                      <img
                        src="assets/usecase/VehicleClassification.png"
                        height={40}
                        className="mx-2"
                        alt="not found"
                      />
                      <h3>
                        <div>Vehicle Classification</div>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div className="col-lg-6 d-flex justify-content-end align-items-center">
            <img
              src="assets/img/VehicleAnalytics.png"
              className="img-fluid"
              alt=""
              width={500}
            />
          </div>
        </div>
      </div>
    ),
    "Occupational Safety": (
      <div className="container" data-aos="fade-up">
        <div className="row feture-tabs g-4" data-aos="fade-up">
          <div className="col-lg-6">
            <section id="features" className="features">
              <div className="container">
                <div
                  className="row g-5"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <div className="col-lg-6">
                    <div className="icon-box">
                      <img
                        src="assets/usecase/helmet.png"
                        height={40}
                        className="mx-2"
                        alt="not found"
                      />
                      <h3>
                        <div>Helmet Detection</div>
                      </h3>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="icon-box">
                      <img
                        src="assets/usecase/vest.png"
                        height={40}
                        className="mx-2"
                        alt="not found"
                      />
                      <h3>
                        <div>Vest Detection</div>
                      </h3>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="icon-box">
                      <img
                        src="assets/usecase/Fire.png"
                        height={40}
                        className="mx-2"
                        alt="not found"
                      />
                      <h3>
                        <div>Early Fire and Smoke Alert</div>
                      </h3>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="icon-box">
                      <img
                        src="assets/usecase/forklift.png"
                        height={40}
                        className="mx-2"
                        alt="not found"
                      />
                      <h3>
                        <div>MHE Safety Incident Detection</div>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div className="col-lg-6 d-flex justify-content-end align-items-center">
            <img
              src="assets/img/hse.png"
              className="img-fluid"
              alt=""
              width={500}
            />
          </div>
        </div>
      </div>
    ),
    Warehousing: (
      <div className="container" data-aos="fade-up">
        <div className="row feture-tabs g-4" data-aos="fade-up">
          <div className="col-lg-6">
            <section id="features" className="features">
              <div className="container">
                <div
                  className="row g-5"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <div className="col-lg-6">
                    <div className="icon-box">
                      <img
                        src="assets/usecase/carton_count.png"
                        height={40}
                        className="mx-2"
                        alt="not found"
                      />
                      <h3>
                        <div>Carton Inventory Count</div>
                      </h3>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="icon-box">
                      <img
                        src="assets/usecase/sack.png"
                        height={40}
                        className="mx-2"
                        alt="not found"
                      />
                      <h3>
                        <div>Sack Quantity Monitoring</div>
                      </h3>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="icon-box">
                      <img
                        src="assets/usecase/manhour.png"
                        height={40}
                        className="mx-2"
                        alt="not found"
                      />
                      <h3>
                        <div>Conveyor Inventory Monitoring</div>
                      </h3>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="icon-box">
                      <img
                        src="assets/usecase/PersonnelProductivityTracking.png"
                        height={40}
                        className="mx-2"
                        alt="not found"
                      />
                      <h3>
                        <div>Personnel Productivity Tracking</div>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div className="col-lg-6 d-flex justify-content-end align-items-center">
            <img
              src="assets/img/warehouseAnalytics.png"
              className="img-fluid"
              alt=""
              width={500}
            />
          </div>
        </div>
      </div>
    ),
    "Face Recognition": (
      <div className="container" data-aos="fade-up">
        <div className="row feture-tabs g-4" data-aos="fade-up">
          <div className="col-lg-6">
            <section id="features" className="features">
              <div className="container">
                <div
                  className="row g-5"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <div className="col-lg-6">
                    <div className="icon-box">
                      <img
                        src="assets/usecase/face_recording.png"
                        height={40}
                        className="mx-2"
                        alt="not found"
                      />
                      <h3>
                        <div>Face Recording</div>
                      </h3>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="icon-box">
                      <img
                        src="assets/usecase/face_recognition.png"
                        height={40}
                        className="mx-2"
                        alt="not found"
                      />
                      <h3>
                        <div>Face Recognition</div>
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <div className="col-lg-6 d-flex justify-content-end align-items-center">
            <img
              src="assets/img/face.jpg"
              className="img-fluid"
              alt=""
              width={500}
            />
          </div>
        </div>
      </div>
    ),
  };

  return (
    <section id="usecase" className="portfolio">
      <div className="container" data-aos="fade-up">
        <header className="section-header">
          <h2>USE CASES</h2>
          <p>Unlock Endless Possibilities with Pratham</p>
        </header>
        <div className="row" data-aos="fade-up" data-aos-delay="100">
          <div
            className="col-lg-12 d-flex justify-content-center"
            style={{ marginBottom: "1rem" }}
          >
            <ul id="portfolio-flters">
              {tabs.map((item, i) => (
                <li
                  className={selectedTab === item && "filter-active"}
                  onClick={() => setSelectedTab(item)}
                  key={i}
                >
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div>{tabContent[selectedTab]}</div>
      </div>
    </section>
  );
}

export default Usecase;
